import likedUsersMutations from "./liked-users/mutations"

import {
	CREATING_POST,
	CLEAR_POST_LIST,
	CLEAR_CURRENT_POST,
	SET_CURRENT_POST,
	CURRENT_POST_LOADING,
	POST_LIST_LOADING,
	PUSH_POST,
	SET_ATTACHMENTS_LOADING,
	SET_SINGLE_ATTACHMENT_LOADING,
	SET_ATTACHMENT_OFFSET,
	UPDATE_POST
} from "@/store/mutations.type"

export default {
	[CREATING_POST](state, flag) {
		state.creatingPost = flag
	},

	[CLEAR_POST_LIST](state) {
		state.posts = []
		state.postListFetchCompleted = false
		state.postListOffset = 0
	},

	[CLEAR_CURRENT_POST](state) {
		state.currentPost = {}
		state.currentPostLoading = false
		state.attachmentsLoading = false
		state.attachmentsOffset = 0
		state.attachmentsFullyLoaded = false
	},

	[SET_CURRENT_POST](state, post) {
		state.currentPost = post
	},

	[SET_ATTACHMENT_OFFSET](state, attachmentsLength) {
		if(attachmentsLength === state.attachmentsLimit) {
			state.attachmentsOffset += state.attachmentsLimit
		} else {
			state.attachmentsFullyLoaded = true
		}
	},

	[CURRENT_POST_LOADING](state, flag) {
		state.currentPostLoading = flag
	},

	[POST_LIST_LOADING] (state, flag) {
		state.postListLoading = flag
	},

	[SET_SINGLE_ATTACHMENT_LOADING] (state, flag) {
		state.attachmentLoading = flag
	},

	[PUSH_POST] (state, posts) {
		if(posts.length) {
			posts.forEach((post) => {
				if(post) state.posts.push(post)
			})
		}

		if(posts.length === state.postListLimit) {
			state.postListOffset += state.postListLimit
		} else {
			state.postListFetchCompleted = true
		}
	},

	[SET_ATTACHMENTS_LOADING](state, flag) {
		state.attachmentsLoading = flag
	},

	[UPDATE_POST](state, payload) {
		// Update post list
		const post = state.posts.find(post => post.id === payload.postId)
		if(post) Object.assign(post, payload.values)
		// Also update current single post if on view
		if(payload.postId === state.currentPost.id) Object.assign(state.currentPost, payload.values)
	},

	...likedUsersMutations
}